import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useCollectionMethodChartsDataContext } from './hooks/useCollectionMethodChartsDataContext';

export const FamiliesPerEstablishmentSocialHealth = () => {
    const { chartData } = useCollectionMethodChartsDataContext();


    return (
        <SimpleBars
            title={'Total de Famílias por Estabelecimento de Assistência Saúde (Top 10)'}
            horizontal={true}
            subtitles={chartData?.familiesPerEstablishmentSocialHealth?.map((item) => item.description)}
            values={chartData?.familiesPerEstablishmentSocialHealth?.map((item) => item.total || 0)}
        />
    );
};
